import { render, staticRenderFns } from "./BusinessLoanDetails.vue?vue&type=template&id=556f0b42&scoped=true"
import script from "./BusinessLoanDetails.vue?vue&type=script&lang=js"
export * from "./BusinessLoanDetails.vue?vue&type=script&lang=js"
import style0 from "./BusinessLoanDetails.vue?vue&type=style&index=0&id=556f0b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f0b42",
  null
  
)

export default component.exports